// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__KUkbs","title":"InfoRow_title__2Rm32"};